import React, { Component } from 'react';
import DeviceForm from 'components/DeviceForm';

const mapModelsToValues = (sub, preactivation = {}, simoDevice) => {
  if (preactivation === null) {
    preactivation = {};
  }

  if (simoDevice) {
    return {
      serial_number: simoDevice.serial_number || undefined,
      sync: false,
    };
  }

  return {
    device_id: sub?.device_id || preactivation.device_id,
    device_status: sub?.device_status,
    icc_id: sub?.icc_id || preactivation.icc_id,
    platform: sub?.platform,
  };
};

class UpdateDevice extends Component {
  componentDidMount() {
    this.clearRequest();
    this.fetchAllPlans();
  }

  componentDidUpdate(oldProps) {
    if (oldProps.subId !== this.props.subId) {
      this.clearRequest();
    }
  }

  clearRequest() {
    const { resetResource, resourceType } = this.props;
    resetResource(resourceType, {
      requestKey: 'updateDevice',
    });
  }

  transformValues = (values) => {
    const { isTracfone, isSimo } = this.props;
    if (isTracfone) {
      let newValues = { ...values };
      if (!values.device_id && !values.device_make) {
        newValues.device_id = null;
      }
      if (!values.icc_id) {
        newValues.icc_id = null;
      }
      return newValues;
    }

    if (isSimo) {
      let newValues = { ...values };

      newValues.device_status = undefined;

      return newValues;
    }

    return values;
  };

  fetchAllPlans() {
    const { fetchAllPlans } = this.props;

    if (fetchAllPlans) {
      fetchAllPlans();
    }
  }

  render() {
    const {
      updateDevice,
      subId,
      sub,
      simoDevice,
      simoDeviceId,
      preactivationId,
      preactivation,
      ...props
    } = this.props;

    if ((!sub && !simoDevice) || (preactivationId && !preactivation)) {
      return <div>Loading...</div>;
    }

    const device = mapModelsToValues(sub, preactivation, simoDevice);

    return (
      <DeviceForm
        initialValues={device}
        onSubmit={(values) =>
          updateDevice(subId || simoDeviceId, this.transformValues(values))
        }
        sub={sub}
        {...props}
        {...{ subId }}
      />
    );
  }
}

export default UpdateDevice;
